// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import dayjs from 'dayjs';

export type ServiceType =
  | 'gcp_rev'
  | 'psfdaf_rev'
  | 'gcp_pipeline'
  | 'psfdaf_pipeline';

interface DataPoint {
  year: string;
  amount: number;
}

interface LegendData {
  legend_key: ServiceType;
  legend_name: string;
  items: DataPoint[] | null;
}

export interface CombinedChartData {
  year: string;
  month: string;
  [key: string]: string | number;
}

export const transformAndGroupDataByMonth = (
  data: LegendData[]
): CombinedChartData[] => {
  const chartMap = new Map<string, CombinedChartData>();

  data.forEach((legend) => {
    if (legend.items) {
      legend.items.forEach((item) => {
        const date = dayjs(item.year);
        const monthKey = date.format('YYYY-MM'); // e.g., "2024-11"

        // Get the existing object for this month/year or create a new one
        if (!chartMap.has(monthKey)) {
          chartMap.set(monthKey, {
            year: date.format('YYYY'),
            month: date.format('MMMM'),
            monthKey: getTickLabel(date.format('MMMM'), date.format('YYYY')),
          });
        }

        // Add the amount under the dynamic legend_key
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const monthObject = chartMap.get(monthKey)!;
        monthObject[legend.legend_key] = item.amount;
      });
    }
  });

  // Convert the Map values to an array
  return Array.from(chartMap.values())?.map((item) => ({
    ...item,
    gcp_rev: item.gcp_rev || 0,
    gcp_pipeline: item.gcp_pipeline || 0,
    psfdaf_rev: item.psfdaf_rev || 0,
    psfdaf_pipeline: item.psfdaf_pipeline || 0,
    total:
      (item.gcp_rev || 0) +
      (item.gcp_pipeline || 0) +
      (item.psfdaf_rev || 0) +
      (item.psfdaf_pipeline || 0),
  }));
};

const getTickLabel = (month: string, year: string): string => {
  const yearStr = `, ${String(year).substring(2, 4)}`;
  return `${month.substring(0, 3)}${yearStr}`;
};
